<template>
	<div class="main-header-div">
        <div class="search-bg">
                <homeHeader />
                <div class="inner search-content">
                    <div class="search-wrapper">
                        <div class="header-img" @click="goHome"></div>
                        <div  class="search-input">
                            <div class="search-div">
                                <input type="text" class="search-ipt" v-model="searchVal" @keyup.enter="search" />
                                <button @click="search"><span>搜索</span><img src="@/assets/sousuo.png"></button>
                                <!-- <el-input placeholder="请输入关键字查询......" :size="isMobile ? 'mini':''" v-model="searchVal" >
                                    <template slot="append">
                                        <el-button class="search-btn" :size="isMobile ? 'mini':''" @click="search"><i class="el-icon-search" ></i></el-button>
                                    </template>
                                </el-input> -->
                            </div>
                            <div  class="huo-div-wrapper">
                            	<span v-for="(item,index) of hotSearch" :key="index" class="hot-span-wrapper" @click="routeUrl(item.hotKeys.concat('、',item.remark))"> <span class="hot-span" :title="item.remark">{{item.hotKeys}}</span></span>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
        <div class="nav-div">
            <div class="inner nav-warapper">
                <div class="nav-item" :style="{width: Number(Number(100/navMenus.length).toFixed(2)) + '%'}" :class="{'nav-item-selected': item.path.includes(routeName)}" v-for="(item,index) of navMenus" :key="index" 
                @click="clickNavHandle(item,index)">
                    <div><!-- <i :class="item.icon"></i> --><span class="nav-title">{{item.name}}</span></div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
import homeHeader from '@/components/home/homeHeader.vue'
export default {
    name: 'mainHeader',
    components: { homeHeader },
    props: {
        'isMobile': Boolean,
        'screenWidth': Number
    },
    watch:{
        $route(to,from){
            this.routeName = to.name
        }
    },
    created(){
        this.routeName = this.$route.name
        this.hotKeys()
    },
    mounted () {

    },
    data() {
        return {
            routeName: 'homePage',
            searchVal: '',
            selectedKey: '',
            searchKeys: [{ key: 'shangbiao', name: '找商标' }, { key: 'dili', name: '找地理标志' }, { key: 'zhengce', name: '找政策法规' }],
            hotSearch: [],
            navMenus: [{name:'首页',icon:'el-icon-s-home',path:'/homePage'},{name:'信息快查',icon:'el-icon-tickets',path:'/infoQuery'},{name:'事项快办',icon:'el-icon-coordinate',path:'/transHandle'},{name:'数据快报',icon:'el-icon-service',path:'/dataFlash'},{name:'机构快访',icon:'el-icon-menu',path:'/serviceResource'}]
        }
    },
    methods: {
        hotKeys(){
          let _this = this
            this.$http({
              url: this.$http.adornUrl(`/bus/hotKeys/getHotKeysList`),
              method: 'get',
            }).then(({ data }) => {
              if (data.code === 0) {
                 let len = data.data.length
                if (len > 6) {
                  _this.hotSearch = data.data.slice(0,6)
                }else {
                  _this.hotSearch = data.data
                }
              }
            })
        },
        goHome(){
          this.$router.push("homePage")
        },
    	searchKey(item){
    		this.selectedKey = item.key
    		console.log('data: ', item)
    	},
        search(){
            if (this.searchVal && this.searchVal.trim() !== '') {
                this.routeUrl(this.searchVal)
            }
        },
        routeUrl(key){
            const routeUrl = this.$router.resolve({
                path: 'mySearch',
                query: {searchVal: key}
            })
            window.open(routeUrl.href, "_blank")
        },
    	clickNavHandle(menu,index){
    		console.log('菜单：',menu)
            /*if (menu.path === '/dataFlash') {
                window.open('http://zscqj.hubei.gov.cn/fbjd/xxgkml/tjxitb/tjxxt/#test',"_blank")
                return
            }*/
            let pathName = this.$route.name
            if (!menu.path.includes(pathName)) {
    		  this.$router.push(menu.path)
            }
    	}
    }
}
</script>